import { Injectable } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AcceptanceModalComponent } from '../components/acceptance-modal/acceptance-modal.component';

@Injectable({ providedIn: 'root' })
export class AuthFlows {
  constructor(
    private modalController: ModalController,
    private alertController: AlertController
  ) { }

  //Solicitar aceptacion antes de Login.
  async presentAcceptance(isRecheck = false) {
    const modal = await this.modalController.create({
      component: AcceptanceModalComponent,
      cssClass: 'auto-height',
      backdropDismiss: !isRecheck,
      componentProps: {
        'isRecheck': isRecheck
      }
    });
    await modal.present();
    const { data } = await modal.onWillDismiss();
    return data;
  }

  async handleAuthError(err: any) {
    if (!err) return;
    switch (err.code) {
      case 'auth/email-already-in-use': // MN: i think... this one when it exists but has no psw
      case 'auth/account-exists-with-different-credential': { // this one when exists and has a psw (just guessing...)
        const alert = await this.alertController.create({
          header: 'Cuenta ya existe',
          subHeader: 'Ya existe una cuenta con este correo electrónico',
          message: 'Entra con tu otra cuenta. Puedes recuperar tu contraseña si no la recuerdas.',
          buttons: ['OK']
        });
        await alert.present();
        break;
      }
    }
  }
}
